import React, { useEffect, Suspense } from 'react';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import Layout from './hoc/Layout/Layout';
import BurgerBuilder from './containers/BurgerBuilder/BurgerBuilder';
import HomePage from './containers/HomePage/HomePage';
import Logout from './containers/Auth/Logout/Logout';
import FirebaseFileUpload from './containers/FirebaseFileUpload/FirebaseFileUpload';
import PdfTable from './containers/Table/pdfTable';
import About from './components/UI/About/About';

import * as actions from './store/actions/index';
import 'bootstrap/dist/css/bootstrap.min.css';

const Editor = React.lazy(() => {
  // return import('./containers/Editor/Editor');
  return import('./containers/Editor/Editor1');
});

const UpdateFileData = React.lazy(() => {
  return import('./containers/UpdateFileData/UpdateFileData');
});

const QuizList = React.lazy(() => {
  return import('./containers/QuizList/QuizList');
});

const ResourceList = React.lazy(() => {
  return import('./containers/ResourceList/ResourceList');
});

const BookCheckout = React.lazy(() => {
  return import('./containers/BookCheckout/BookCheckout');
});

const BookCheckin = React.lazy(() => {
  return import('./containers/BookCheckin/BookCheckin');
});

const HardLibrary = React.lazy(() => {
  return import('./containers/HardLibrary/HardLibrary');
});

const AddHardBook = React.lazy(() => {
  return import('./containers/AddHardBook/AddHardBook');
});

const Orders = React.lazy(() => {
  return import('./containers/Orders/Orders');
});

const Auth = React.lazy(() => {
  return import('./containers/Auth/Auth');
});

const BlogMain = React.lazy(() => {
  return import('./containers/Blog/BlogMain');
});

const MultiBlog = React.lazy(() => {
  return import('./containers/Blog/MultiBlog');
});

const BlogEditorMain = React.lazy(() => {
  return import('./containers/Blog/BlogEditorMain');
});

const BlogList = React.lazy(() => {
  return import('./containers/BlogList/BlogList');
});

const BlogEditorList = React.lazy(() => {
  return import('./containers/BlogList/BlogEditorList');
});

const VlogMain = React.lazy(() => {
  return import('./containers/Vlog/VlogMain');
});

const VlogList = React.lazy(() => {
  return import('./containers/VlogList/VlogList');
});

const app = props => {
  const { onTryAutoSignup } = props;

  useEffect(() => {
    onTryAutoSignup();
  }, [onTryAutoSignup]);

  let routes = (
    <Switch>
      <Route path="/auth" render={props => <Auth {...props} />} />
      <Route path="/BurgerBuilder" exact component={BurgerBuilder} />
      <Route path="/PdfTable" exact component={PdfTable} />
      <Route path="/Editor" exact component={Editor} />
      {/* <Route path="/BlogList" component={BlogList} /> */}
      <Route path="/BlogList" component={BlogEditorList} />
      <Route path="/VlogList" component={VlogList} />
      <Route path="/QuizList" component={QuizList} />
      <Route path="/MultiBlog" component={MultiBlog} />
      <Route path="/ResourceList" component={ResourceList} />
      <Route path="/VlogMain" component={VlogMain} />
      {/* <Route path="/BlogMain" component={BlogMain} /> */}
      <Route path="/BlogMain" component={BlogEditorMain} />
      <Route path="/UpdateFileData" component={UpdateFileData} />
      <Route path="/About" component={About} />
      <Route path="/" exact component={HomePage} />
      <Redirect to="/" />
    </Switch>
  );

  
  if (props.isAuthenticated) {
    routes = (
      <Switch>
        <Route path="/orders" render={props => <Orders {...props} />} />
        <Route path="/logout" component={Logout} />
        <Route path="/auth" render={props => <Auth {...props} />} />
        <Route path="/BurgerBuilder" exact component={BurgerBuilder} />
        <Route path="/FirebaseFileUpload" exact component={FirebaseFileUpload} />
        <Route path="/AddHardBook" exact component={AddHardBook} />
        {/* <Route path="/BlogList" exact component={BlogList} /> */}
        <Route path="/BlogList" exact component={BlogEditorList} />
        <Route path="/VlogList" component={VlogList} />
        <Route path="/QuizList" component={QuizList} />
        <Route path="/VlogMain" component={VlogMain} />
        <Route path="/ResourceList" component={ResourceList} />
        <Route path="/About" component={About} />
        {/* <Route path="/BlogMain" render={props => <BlogMain {...props} />}  /> */}
        <Route path="/BlogMain" render={props => <BlogEditorMain {...props} />}  />
        <Route path="/MultiBlog" render={props => <MultiBlog {...props} />}  />
        <Route path="/UpdateFileData" render={props => <UpdateFileData {...props} />} />
        <Route path="/PdfTable" render={props => <PdfTable {...props} />}  />
        <Route path="/HardLibrary" render={props => <HardLibrary {...props} />}  />
        <Route path="/BookCheckout" render={props => <BookCheckout {...props} />}  />
        <Route path="/BookCheckin" render={props => <BookCheckin {...props} />}  />
        <Route path="/" render={props => <HomePage {...props} />}/>
        <Redirect to="/" />
      </Switch>
    );
  }

  return (
    <div>
      <Layout>
        <Suspense fallback={<p>Loading...</p>}>{routes}</Suspense>
      </Layout>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.token !== null,
    admin: state.auth.admin,
    org: state.auth.org,
    userEmail: state.auth.userEmail,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState())
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(app)
);



// WEBPACK FOOTER //
// ./src/App.js